module.exports = __webpack_public_path__ + "static/media/gm.8cdda75e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/gm.svg
// module id = 130
// module chunks = 0